import { httpClient } from "@sazka/utils/http-clients/http-client";
import { QuickSearchResponse } from "../models/quick-search-models";

export namespace QuickSearchApi {
    export async function getSearchResult(value: string) {
        return (
            await httpClient.get<QuickSearchResponse>("/api/search", {
                params: {
                    searchText: value,
                },
            })
        ).data;
    }
}
